import { render, staticRenderFns } from "./HatsuiDataDisplay.vue?vue&type=template&id=63b80fd4&scoped=true&"
import script from "./HatsuiDataDisplay.vue?vue&type=script&lang=ts&"
export * from "./HatsuiDataDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./HatsuiDataDisplay.vue?vue&type=style&index=0&id=63b80fd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b80fd4",
  null
  
)

export default component.exports